module.exports = __webpack_public_path__ + "static/media/fossasia-logo.acb6eeb1.jpg";